module.exports = __webpack_public_path__ + "/images/shop/icon/cash_on_delivery.svg";